import { Component } from '@angular/core';

@Component({
  selector: 'lis-pricelists',
  imports: [],
  templateUrl: './pricelists.html',
  styleUrl: './pricelists.scss',
})
export class Pricelists {

}
